import { render, staticRenderFns } from "./Union.vue?vue&type=template&id=1dc75a42"
import script from "./Union.vue?vue&type=script&lang=js"
export * from "./Union.vue?vue&type=script&lang=js"
import style0 from "./Union.vue?vue&type=style&index=0&id=1dc75a42&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports